package link.erpango.quip.core.interactor

import link.erpango.quip.data.IDataSource
import link.erpango.quip.data.remote.DResponse
import link.erpango.quip.domain.entities.DMySparePart
import link.erpango.quip.domain.entities.DShareResult
import link.erpango.quip.domain.usecases.IMySparePartsUseCase

/**
 * Interactor de repuestos personales ("mis repuestos").
 * Wrapper fino sobre el repositorio remoto; sin persistencia local en esta fase.
 */
class MySparePartsInteractor(
    override val data: IDataSource
): IMySparePartsUseCase, IInteractor {

    override suspend fun listMySpareParts(
        vehicleVin: String?,
        brandId: Int?,
        modelId: Int?,
        search: String?
    ): DResponse<List<DMySparePart>> {
        return data.remote.mySpareParts.listMySpareParts(vehicleVin, brandId, modelId, search)
    }

    override suspend fun getMySparePart(id: Long): DResponse<DMySparePart> {
        return data.remote.mySpareParts.getMySparePart(id)
    }

    override suspend fun createMySparePart(part: DMySparePart): DResponse<DMySparePart> {
        return data.remote.mySpareParts.createMySparePart(part)
    }

    override suspend fun updateMySparePart(id: Long, part: DMySparePart): DResponse<DMySparePart> {
        return data.remote.mySpareParts.updateMySparePart(id, part)
    }

    override suspend fun deleteMySparePart(id: Long): DResponse<Unit> {
        return data.remote.mySpareParts.deleteMySparePart(id)
    }

    override suspend fun shareMySparePart(partId: Long, targetUserId: Int): DResponse<DShareResult> {
        return data.remote.mySpareParts.shareMySparePart(partId, targetUserId)
    }
}
